import { FormData, RequestData, PdfRequest } from "./types";
import axios from "axios";

export const createRequest = (formData: FormData) => {
  const numericFormData = {
    ZIB_revenue: Number(formData.ZIB_revenue),
    ZIB_cost: Number(formData.ZIB_cost),
  };

  const requestDataZIB: RequestData = {
    grossIncome: numericFormData.ZIB_revenue,
    actualCost: numericFormData.ZIB_cost,
    selfEmployedStatus: "secondary",
  };
  return requestDataZIB;
};

export const executeRequest = async (requestData: RequestData) => {
  return await axios({
    method: "post",
    url: "/api/tax-api",
    data: requestData,
    headers: { "Content-Type": "application/json" },
  }).catch(function (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error;
    }
  });
};

export const executePdfRequest = async (data: PdfRequest) => {
  return await axios({
    method: "post",
    url: "/api/send-pdf",
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
  }).catch(function (error) {
    if (error.response) {
      console.error(error.response.data);
      throw error.response.data;
    } else {
      throw error;
    }
  });
};
